import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=aa12ec6e&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/font.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/content.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports